'use client'

import { IconPigMoney } from '@tabler/icons-react'
import clsx from 'clsx'

import { Cart } from 'modules/cart'
import { isNotNilOrEmpty } from 'shared/utils/ramda'

import styles from './SubmitEditSaleOrderModalSummary.module.scss'

const SubmitEditSaleOrderModalSummary = ({ cart }: { cart: Cart | null }) => {
  const savings = cart?.savingsTotal?.formatted || null
  const itemsPrice = cart?.itemsValue?.gross?.formatted || '0,00 zł'
  const cartTotalValue = cart?.paymentValue.formatted || '0,00 zł'
  const hasSelectedSlot = isNotNilOrEmpty(cart?.deliverySlotId)
  const deliveryCost = hasSelectedSlot
    ? cart?.deliveryCost?.formatted || '0,00 zł'
    : 'Wybierz termin'

  const hasPromoCode = cart?.discountCodesTotalValue?.value !== 0
  const promoCodesDiscount = hasPromoCode
    ? cart?.discountCodesTotalValue?.formatted || ''
    : ''

  return (
    <div className={styles.detailsItem}>
      <p className={styles.detailsItemLabel}>
        <b>Podsumowanie</b>
      </p>

      <div className={styles.detailsCard}>
        <div className={styles.summaryWrapper}>
          <div className={styles.summaryItem}>
            <p className={styles.summaryItemText}>Wartość produktów</p>
            <p
              className={clsx(
                styles.summaryItemText,
                styles.summaryItemBoldText
              )}
              dangerouslySetInnerHTML={{ __html: itemsPrice }}
            />
          </div>

          <div className={styles.summaryItem}>
            <p className={styles.summaryItemText}>Koszt dostawy</p>
            <p
              className={clsx(
                styles.summaryItemText,
                styles.summaryItemBoldText
              )}
              dangerouslySetInnerHTML={{ __html: deliveryCost }}
            />
          </div>

          {isNotNilOrEmpty(promoCodesDiscount) && (
            <div className={styles.summaryItem}>
              <p className={styles.summaryItemText}>Kody rabatowe</p>
              <p
                className={clsx(
                  styles.summaryItemText,
                  styles.summaryItemBoldText
                )}
                dangerouslySetInnerHTML={{ __html: promoCodesDiscount }}
              />
            </div>
          )}

          <div className={styles.summaryItem}>
            <p className={styles.summaryItemText}>Wartość całkowita koszyka</p>
            <p
              className={clsx(
                styles.summaryItemText,
                styles.summaryItemBoldText,
                styles.summaryItemBoldTextLarge
              )}
              dangerouslySetInnerHTML={{ __html: cartTotalValue }}
            />
          </div>

          {savings && (
            <div className={styles.summaryItem}>
              <div className={styles.discountLabel}>
                <div className={styles.discountLabelText}>
                  Dzięki <b>Lokalnemu Rolnikowi</b> oszczędzasz
                </div>
              </div>
              <div className={styles.discountLabel}>
                <IconPigMoney size={20} />
                <div
                  className={styles.discountValue}
                  id='discount_value'
                  dangerouslySetInnerHTML={{ __html: savings }}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default SubmitEditSaleOrderModalSummary
